import React from 'react'
import { connect } from 'react-redux'

import * as actionCreators from '../../../../../../src/store/actions'
import { mapStateToProps } from '../../../../../../src/utils'

const classNames = require('classnames')

export class VitaeMandatoryProfilePopupViewComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillUnmount() {
    // Fix Warning: Can't perform a React state update on an unmounted component
    this.setState = () => {}
  }

  render() {
    return <div className={classNames('')}> Not implemented</div>
  }
}

export default connect(
  mapStateToProps,
  actionCreators
)(VitaeMandatoryProfilePopupViewComponent)
